<app-pageheader [Parent]="this">
    <add-button AddRoute="/integrations/parkchirp/new/edit"></add-button>
  </app-pageheader>
  
  <app-datalistview [Columns]="Columns" [ShowMap]="false" ApiUrl="integrations/parkchirp/configurations/search"
    [AllowEdit]="true" EditUrl="/integrations/parkchirp/:id">
    <app-filter-set>
      <div app-search-filter></div>
      <div app-search-button></div>
    </app-filter-set>
  </app-datalistview>